var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sp_audio_input_btn",class:{ recording: _vm.isRecording },on:{"click":_vm.toggleVoiceRecognition}},[_c('SoundBarsIcon',{attrs:{"isRecording":_vm.isRecording,"recordingColor":"#dc2626"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }